import { SimonSpriteDemo } from "../../../../src/adhoc/blog/castletypia.js";
import * as React from 'react';
export default {
  SimonSpriteDemo,
  React
};